import { render } from "./contenedor.vue?vue&type=template&id=3662d995&scoped=true"
import script from "./contenedor.vue?vue&type=script&lang=js"
export * from "./contenedor.vue?vue&type=script&lang=js"

import "./contenedor.vue?vue&type=style&index=0&id=3662d995&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3662d995"]])

export default __exports__